import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { useHeatMapGraphModel } from './container/model'
import { useHeatMapGraphOption, HeatMapGraphOptions } from './container/options'
import { useHeatMapGraphRenderOption } from './container/render'
import { useHeatMapGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { HeatmapChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  HeatmapChart,
  VisualMapComponent,
  CanvasRenderer,
])

export const HeatMapGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useHeatMapGraphOption({ dashBoard, options, targetList })
  const graphData = useHeatMapGraphModel({ dashBoard, dataList, conditions, graphOption })
  const renderOption = useHeatMapGraphRenderOption({ graphOption, graphData })
  const events = useHeatMapGraphEvents({ graphOption, onChangeCondition })

  useEffect(
    () => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )

  const { timeDef, valueDef } = graphOption
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        dashBoard={dashBoard}
        keys={[timeDef?.key, valueDef?.key]}
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const HeatMapGraphFactory: GraphType = {
  title: 'ヒートマップ',
  options: HeatMapGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <HeatMapGraph<T> {...props} />,
}
